module.exports = __webpack_public_path__ + "img/vilagos-alap2.b897202d.png";